/**
 * Finds the rawSequenceMap encoding whose `index` exactly matches `pos`.
 */
const findEntry = (rawSequenceMap, pos) => {
    if (rawSequenceMap.length === pos) {
        return {
            start: rawSequenceMap.length + 1
        };
    }
    return rawSequenceMap.find(item => item.index === pos) ?? null;
}

/**
 * Resolves the `start` of the encoding at index `pos`.
 */
const lookup = (rawSequenceMap, pos) => {
    return findEntry(rawSequenceMap, pos)?.start ?? null;
}

export {
    findEntry,
    lookup
}